import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { endOfDay, mapIds, startOfDay } from '@core/utils/filters-utils';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { DateIntervalValidation } from '@validators/date-interval-validation';
import { DateValidation } from '@validators/date.validation';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import english from '../i18n/en.json';
import spanish from '../i18n/es.json';
import portuguese from '../i18n/pt.json';
var FilterComponent = /** @class */ (function () {
    function FilterComponent(formBuilder, translateService, fuseTranslationLoaderService) {
        this.formBuilder = formBuilder;
        this.translateService = translateService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.defaultFilterValues = {
            dateFilterType: 'openedAt',
            initialDate: moment().subtract(1, 'month'),
            finalDate: moment(),
            locations: null,
            segments: null,
            companies: null,
            locationGroups: null,
            maintenanceTypes: null
        };
        this.filtersChanged = new BehaviorSubject(this.toFilter(true));
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.filterTypeOptions = [
            {
                text: this.translateService.instant('DEADLINES.FILTERS.FILTER_BY.OPENED_AT'),
                value: 'openedAt',
            },
            {
                text: this.translateService.instant('DEADLINES.FILTERS.FILTER_BY.SCHEDULED_AT'),
                value: 'scheduledAt',
            },
            {
                text: this.translateService.instant('DEADLINES.FILTERS.FILTER_BY.CLOSED_AT'),
                value: 'closedAt',
            }
        ];
    }
    FilterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isFilterExpanded = false;
        this.filterForm = this.formBuilder.group({
            dateFilterType: [this.defaultFilterValues.dateFilterType, [Validators.required]],
            initialDate: [this.defaultFilterValues.initialDate, [Validators.required, DateValidation.validate]],
            finalDate: [this.defaultFilterValues.finalDate, [Validators.required, DateValidation.validate]],
            locations: this.defaultFilterValues.locations,
            segments: this.defaultFilterValues.segments,
            companies: this.defaultFilterValues.companies,
            locationGroups: this.defaultFilterValues.locationGroups,
            maintenanceTypes: this.defaultFilterValues.maintenanceTypes
        }, {
            validators: [
                DateIntervalValidation.validate({
                    from: 'initialDate',
                    to: 'finalDate',
                    maxDiffLte: 1,
                    unit: 'year'
                })
            ]
        });
        this.filterForm.valueChanges
            .pipe(filter(function () { return _this.filterForm.valid; }))
            .subscribe(function () { return _this.updateFilter(); });
    };
    FilterComponent.prototype.beforePrint = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.isFilterExpanded = true;
                return [2 /*return*/];
            });
        });
    };
    FilterComponent.prototype.toQuery = function (_a) {
        var isDefault = _a.isDefault, isFooter = _a.isFooter;
        var value = isDefault ? this.defaultFilterValues : this.filterForm.value;
        var initialDate = moment(value.initialDate).startOf('day');
        var finalDate = moment(value.finalDate).endOf('day');
        var interval = finalDate.diff(initialDate, 'days');
        var previousInitialDate = moment(initialDate).subtract(interval, 'days');
        var previousFinalDate = moment(initialDate).subtract(1, 'days');
        var where = {
            locationId_in: mapIds(value.locations),
            segmentId_in: mapIds(value.segments),
            companyId_in: mapIds(value.companies),
            maintenanceTypeId_in: mapIds(value.maintenanceTypes),
            locationGroupId_in: mapIds(value.locationGroups)
        };
        where[value.dateFilterType + "_gte"] = startOfDay(isFooter ? previousInitialDate : initialDate);
        where[value.dateFilterType + "_lte"] = endOfDay(isFooter ? previousFinalDate : finalDate);
        return where;
    };
    FilterComponent.prototype.toFilter = function (isDefault) {
        return {
            currentWhere: this.toQuery({ isDefault: isDefault, isFooter: false }),
            footerWhere: this.toQuery({ isDefault: isDefault, isFooter: true }),
            isFiltered: isDefault ? false : JSON.stringify(this.defaultFilterValues) !== JSON.stringify(this.filterForm.value)
        };
    };
    FilterComponent.prototype.updateFilter = function () {
        var params = this.toFilter(false);
        this.filtersChanged.next(params);
    };
    FilterComponent.prototype.clearFilters = function () {
        this.filterForm.patchValue(this.defaultFilterValues);
    };
    return FilterComponent;
}());
export { FilterComponent };
